import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { EMarketingClientPath } from '~/models/api'
import { store } from '~/store'

// Hook primarily used in the following conditions:
// - When a user logs out, they should be redirected to the home page.
// - When a user logs out, from another tab, they should be redirected to the home page.
const useRedirectOnEmptyStore = () => {
  // keeping track of previous state ( if user has been logged in )
  // to avoid the first trigger of the useEffect where I navigate the user to home screen
  const [hasUserBeenLoggedIn, setHasUserBeenLoggedIn] = useState(false)
  const user = store((state) => state.user)
  const navigate = useNavigate()

  useEffect(() => {
    if (hasUserBeenLoggedIn && !user?.id) {
      navigate(EMarketingClientPath.home)
    }
  }, [user, hasUserBeenLoggedIn, navigate])

  useEffect(() => {
    if (!hasUserBeenLoggedIn && user?.id) {
      setHasUserBeenLoggedIn(true)
    }
  }, [hasUserBeenLoggedIn, user?.id])
}

export default useRedirectOnEmptyStore
